import axios from "axios";
import { toast } from "react-toastify";
import authHeader from "./auth-header";

export const sendDocumentEmail = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/document/send-email`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg || "Email sent successfully!");
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error sending email");
      throw err;
    });
};

export const getDocumentWhatsAppRecipients = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/document/send-whatsapp`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error getting WhatsApp recipients");
      throw err;
    });
};

export const uploadDocument = (file, filename) => {
  const formData = new FormData();
  // filename must be appended before file so multer can read it in diskStorage
  formData.append("filename", filename);
  formData.append("file", file);

  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/document/upload`, formData, {
      headers: {
        ...authHeader(),
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error uploading file");
      throw err;
    });
};

export const checkDocument = (filename) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/document/check`, {
      headers: authHeader(),
      params: { filename },
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      console.error("Error checking document:", err);
      throw err;
    });
};

export const deleteDocument = (filename) => {
  return axios
    .delete(`${process.env.REACT_APP_BASE_URL}/document/delete`, {
      headers: authHeader(),
      params: { filename },
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error deleting file");
      throw err;
    });
};

